angular
    .module('WizApp')
    .factory('HttpRequestTimeInterceptor', [
        function () {
            return {
                request(config) {
                    config.startTime = Date.now();
                    return config;
                },

                response(response) {
                    response.config.endTime = Date.now();
                    response.config.requestTime = response.config.endTime - response.config.startTime;
                    return response;
                }
            };
        }
    ])
;
